<ng-container *appLoad="let opportunities of opportunities$">
  <div class="opportunities" *ngIf="opportunities?.length; else tplNoResults">
    <div class="opportunity" *ngFor="let opportunity of opportunities">
      <lds-card
        [isClickable]="true"
        (click)="router.navigate(['Opportunities', opportunity.id])">
        <div class="row summary">
          <div class="col-auto summary__type">
            <lds-icon
              class="summary__icon"
              [name]="opportunity.opportunityType | opportunityIcon"
              size="md"
              appearance="inherit"></lds-icon>
          </div>

          <div class="col summary__details">
            <div class="row">
              <div class="col-4">
                <div class="summary__title">{{ opportunity.name }}</div>
                <div>
                  {{ displayOpportunityType(opportunity.opportunityType) }}
                </div>
              </div>
              <div class="col-3">
                <div class="summary__subtitle summary--highlight text-center">
                  {{
                    opportunity.settledAmount ?? opportunity.estimatedAmount
                      | currency : undefined : 'symbol-narrow' : '1.0-0'
                  }}
                </div>
              </div>
              <div class="col-3">
                <div>Client Names</div>
                <div class="text-data">{{ opportunity.applicants }}</div>
              </div>
              <div class="col-2">
                <div>{{ opportunity.status }}</div>
                <div class="text-data">
                  {{ opportunity.settlementDate | date : 'dd/MM/yyyy' }}
                </div>
              </div>
            </div>
          </div>

          <div class="col-auto summary__action">
            <lds-icon name="arrow-right" size="sm" appearance="default">
            </lds-icon>
          </div>
        </div>
      </lds-card>
    </div>
  </div>
</ng-container>

<!-- template / no results -->
<ng-template #tplNoResults>
  <lds-empty-state heading="No opportunities available"
                   message="No opportunities found for this contact.">
  </lds-empty-state>
</ng-template>
